if (!customElements.get("custom-select")) {
    class CustomSelect extends HTMLElement {
        constructor() {
            super();
            this.button = this.querySelector(".custom-select__btn");
            this.listbox = this.querySelector(".custom-select__listbox");
            this.selectedOption = this.querySelector('[aria-selected="true"]');

            if (!this.selectedOption) {
                this.selectedOption = this.listbox.firstElementChild;
            }

            this.setButtonWidth();
            window.initLazyScript(this, this.init.bind(this));
        }

        init() {
            this.options = this.querySelectorAll(".custom-select__option");
            this.nativeSelect = document.getElementById(`${this.id}-native`);
            this.swatches = !!Array.from(this.options).find((el) => "swatch" in el.dataset);
            this.focusedClass = "is-focused";
            this.searchString = "";
            this.listboxOpen = false;
            this.focusedOption = null;
            this.buttonClosing = false;


            this.selectedOption = this.querySelector('[aria-selected="true"]');
            if (!this.selectedOption) {
                this.selectedOption = this.listbox.firstElementChild;
            }

            // Bound references kept so they can be removed later.
            this._keydownHandler = this.handleKeydown.bind(this);
            this._outsidePointerHandler = this.handleOutsidePointer.bind(this);

            this.addEventListener("keydown", this._keydownHandler);
            this.button.addEventListener("click", this.handleButtonClick.bind(this));
            this.listbox.addEventListener("mouseover", this.handleMouseover.bind(this));
            this.listbox.addEventListener("mouseleave", this.handleMouseleave.bind(this));
            this.listbox.addEventListener("click", this.handleClick.bind(this));
        }

        // ─── Sibling helpers ────────────────────────────────────────────────────

        static getNextVisibleSibling(elem) {
            if (!elem) return null;
            let sibling = elem.nextElementSibling;
            while (sibling) {
                if (sibling.offsetParent) return sibling;
                sibling = sibling.nextElementSibling;
            }
            return null;
        }
 /**
         * Returns the previous visible sibling element
         * @param {Element} elem - The element to search
         * @returns {Element}
         */
        static getPreviousVisibleSibling(elem) {
            if (!elem) return null;
            while (sibling) {
                if (sibling.offsetParent) return sibling;
                sibling = sibling.previousElementSibling;
            }
            return null;
        }
           /**
         * Adds event listeners when the options list is open.
         */
           addListboxOpenListeners() {
            this.mouseoverHandler = this.handleMouseover.bind(this);
            this.mouseleaveHandler = this.handleMouseleave.bind(this);
            this.clickHandler = this.handleClick.bind(this);
            this.blurHandler = this.handleBlur.bind(this);

            this.listbox.addEventListener("mouseover", this.mouseoverHandler);
            this.listbox.addEventListener("mouseleave", this.mouseleaveHandler);
            this.listbox.addEventListener("click", this.clickHandler);
            this.listbox.addEventListener("blur", this.blurHandler);
        }

        /**
         * Removes event listeners added when the options list was open.
         */
        removeListboxOpenListeners() {
            this.listbox.removeEventListener("mouseover", this.mouseoverHandler);
            this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler);
            this.listbox.removeEventListener("click", this.clickHandler);
            this.listbox.removeEventListener("blur", this.blurHandler);
        }

        /**
         * Handles 'keydown' events on the custom select element.
         * @param {object} evt - Event object.
         */

        // ─── Outside-click detection (replaces blur) ─────────────────────────────
        // Using pointerdown on document means programmatic focus moves (listbox.focus())
        // never accidentally trigger a close, unlike blur events.

        handleOutsidePointer(evt) {
            if (!this.contains(evt.target)) {
                this.hideListbox();
            }
        }

        // ─── Event handlers ──────────────────────────────────────────────────────

        handleKeydown(evt) {
            if (this.listboxOpen) {
                this.handleKeyboardNav(evt);
            } else if (["ArrowUp", "ArrowDown", " ", "Enter"].includes(evt.key)) {
                evt.preventDefault();
                this.showListbox();
            }
        }

        /**
         * Handles 'mousedown' events on the button element.
         * @param {object} evt - Event object.
         */
        handleMousedown(evt) {
            if (!this.listboxOpen && evt.button === 0) {
                this.showListbox();
            }
        }
        handleButtonClick(evt) {
            evt.stopPropagation();
            if (this.listboxOpen) {
                this.buttonClosing = true;

                this.hideListbox();
            } else {
                this.showListbox();
            }
        }

        /**
         * Handles 'mouseover' events on the options list.
         * @param {object} evt - Event object.
         */
        handleMouseover(evt) {
            const li = evt.target.closest("li");
            if (li) this.focusOption(li);
        }

        /**
         * Handles 'mouseleave' events on the options list.
         */
        handleMouseleave() {
            if (this.selectedOption) 
            this.focusOption(this.selectedOption);
        }
 /**
         * Handles 'click' events on the custom select element.
         * @param {object} evt - Event object.
         */
        handleClick(evt) {
            const li = evt.target.closest("li");
            if (evt.target.tagName === "LI") {
                this.selectOption(evt.target);
            }
            if (li) this.selectOption(li);
        }
         /**
         * Handles 'blur' events on the options list.
         */
         handleBlur() {
            setTimeout(() => {
                if (this.listboxOpen && !this.buttonClosing) {
                    this.hideListbox();
                }
                this.buttonClosing = false;
            }, 200);
        }

        /**
         * Handles 'keydown' events on the options list.
         * @param {object} evt - Event object.
         */
        handleKeyboardNav(evt) {
            let optionToFocus;

            // Disable tabbing if options list is open (as per native select element).
            if (evt.key === "Tab") {
                evt.preventDefault();
            }

            const current = () =>
                this.focusedOption || this.selectedOption || this.listbox.firstElementChild;

            switch (evt.key) {
                case "Tab": {
                    evt.preventDefault();
                    const next = evt.shiftKey
                        ? CustomSelect.getPreviousVisibleSibling(current())
                        : CustomSelect.getNextVisibleSibling(current());

                    if (next && !next.classList.contains("is-disabled")) {
                        this.focusOption(next);
                    } else {
                        this.hideListbox();
                    }
                    break;
                }

                // ArrowDown / ArrowUp: walk through options.
                case "ArrowDown":
                case "ArrowUp": {
                    evt.preventDefault();
                    const next = evt.key === "ArrowDown"
                        ? CustomSelect.getNextVisibleSibling(current())
                        : CustomSelect.getPreviousVisibleSibling(current());

                    if (next && !next.classList.contains("is-disabled")) {
                        this.focusOption(next);
                    }
                    break;
                }

                // Enter / Space: confirm the focused option.
                case "Enter":
                case " ":
                    evt.preventDefault();
                    if (this.focusedOption) this.selectOption(this.focusedOption);
                    break;

                // Cancel and close the options list.
                case "Escape":
                    evt.preventDefault();
                    this.hideListbox();
                    break;

                // Search for an option and focus the first match (if one exists).
                default:
                    optionToFocus = this.findOption(evt.key);

                    if (optionToFocus) {
                        this.focusOption(optionToFocus);
                    }
                    break;
            }
        }
           /**
         * Sets the button width to the same as the longest option, to prevent
         * the button width from changing depending on the option selected.
         */
           setButtonWidth() {
            // Get the width of an element without side padding.
            const getHorizontalPadding = (el) => {
                const elStyle = getComputedStyle(el);
                return parseFloat(elStyle.paddingLeft) + parseFloat(elStyle.paddingRight);
            };

            const buttonPadding = getHorizontalPadding(this.button);
            const optionPadding = getHorizontalPadding(this.selectedOption);
            const buttonBorder = this.button.offsetWidth - this.button.clientWidth;
            const optionWidth = Math.ceil(this.selectedOption.getBoundingClientRect().width);

            this.button.style.setProperty(
                "--custom-select-button-width",
                `${optionWidth - optionPadding + buttonPadding + buttonBorder}px`
            );
        }

        /**
         * Shows the options list.
         */


        showListbox() {
            this.listbox.hidden = false;
            this.listboxOpen = true;

            this.classList.add("is-open");
            this.button.setAttribute("aria-expanded", "true");
            this.listbox.setAttribute("aria-hidden", "false");


            const initial = this.selectedOption || this.listbox.firstElementChild;
            if (initial) {
                if (this.focusedOption) this.focusedOption.classList.remove(this.focusedClass);
                this.focusedOption = initial;
                this.focusedOption.classList.add(this.focusedClass);
                this.listbox.setAttribute("aria-activedescendant", initial.id);
            }

            // Move browser focus to the listbox so it receives keydown events.
            // Done in a setTimeout so the listbox is visible before focus() is called.
            setTimeout(() => {
                this.focusOption(this.selectedOption);
                // Add @Dn'D: Add Prevent scroll
                this.listbox.focus({ preventScroll: true });
                

                document.addEventListener("pointerdown", this._outsidePointerHandler);
            });
        }

        hideListbox() {
            if (!this.listboxOpen) return;

            document.removeEventListener("pointerdown", this._outsidePointerHandler);

            this.listbox.hidden = true;
            this.listboxOpen = false;

            this.classList.remove("is-open");
            this.button.setAttribute("aria-expanded", "false");
            this.listbox.setAttribute("aria-hidden", "true");

            if (this.focusedOption) {
                this.focusedOption.classList.remove(this.focusedClass);
                this.focusedOption = null;
            }

            this.button.focus();
            this.removeListboxOpenListeners();
        }

/**
         * Finds a matching option from a typed string.
         * @param {string} key - Key pressed.
         * @returns {?Element}
         */
findOption(key) {
    this.searchString += key;

    // If there's a timer already running, clear it.
    if (this.searchTimer) {
        clearTimeout(this.searchTimer);
    }

    // Wait 500ms to see if another key is pressed, if not then clear the search string.
    this.searchTimer = setTimeout(() => {
        this.searchString = "";
    }, 500);

    // Find an option that contains the search string (if there is one).
    const matchingOption = Array.from(this.options).find((option) => {
        const label = option.innerText.toLowerCase();
        return label.includes(this.searchString) && !option.classList.contains("is-disabled");
    });

    return matchingOption;
}

/**
 * Focuses an option.
 * @param {Element} option - <li> element of the option to focus.
 */
        focusOption(option) {
            if (!option) return;

            if (this.focusedOption) this.focusedOption.classList.remove(this.focusedClass);

            this.focusedOption = option;
            this.focusedOption.classList.add(this.focusedClass);
            this.listbox.setAttribute("aria-activedescendant", option.id);

            // Scroll option into view if needed.
            if (this.listbox.scrollHeight > this.listbox.clientHeight) {
                const scrollBottom = this.listbox.clientHeight + this.listbox.scrollTop;
                const optionBottom = option.offsetTop + option.offsetHeight;
                if (optionBottom > scrollBottom) {
                    this.listbox.scrollTop = optionBottom - this.listbox.clientHeight;
                } else if (option.offsetTop < this.listbox.scrollTop) {
                    this.listbox.scrollTop = option.offsetTop;
                }
            }
        }
           /**
         * Selects an option.
         * @param {Element} option - Option <li> element.
         */

        selectOption(option) {
            if (!option) return;

            if (option !== this.selectedOption) {
                option.setAttribute("aria-selected", "true");
                this.selectedOption.setAttribute("aria-selected", "false");

                if (this.swatches) {
                    this.button.dataset.swatch = option.dataset.swatch || "";
                    const nativeSwatchColor = option.style.getPropertyValue("--native-swatch-color");
                    if (nativeSwatchColor) {
                        this.button.style.setProperty("--native-swatch-color", nativeSwatchColor);
                        this.button.style.setProperty("--native-swatch-image", "");
                    }
                    const nativeSwatchImage = option.style.getPropertyValue("--native-swatch-image");
                    if (nativeSwatchImage) {
                        this.button.style.setProperty("--native-swatch-image", nativeSwatchImage);
                        this.button.style.setProperty("--native-swatch-color", "");
                    }
                }

                this.button.firstElementChild.textContent = option.firstElementChild.textContent;
                this.listbox.setAttribute("aria-activedescendant", option.id);
                this.selectedOption = document.getElementById(option.id);

                if (this.nativeSelect) {
                    this.nativeSelect.value = option.dataset.value;
                    this.nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));
                } else {
                    this.dispatchEvent(new CustomEvent("change", {
                        bubbles: true,
                        detail: {
                            selectedValue: option.dataset.value,
                            productUrl: option.dataset.productUrl,
                        },
                    }));
                }
            }

            this.hideListbox();
        }

        // ─── Type-ahead ──────────────────────────────────────────────────────────

        findOption(key) {
            this.searchString += key;
            if (this.searchTimer) clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => { this.searchString = ""; }, 500);

            return Array.from(this.options).find((option) => {
                return option.innerText.toLowerCase().includes(this.searchString)
                    && !option.classList.contains("is-disabled");
            });
        }

        // ─── Button width ────────────────────────────────────────────────────────

        setButtonWidth() {
            const getHorizontalPadding = (el) => {
                const s = getComputedStyle(el);
                return parseFloat(s.paddingLeft) + parseFloat(s.paddingRight);
            };

            const buttonPadding = getHorizontalPadding(this.button);
            const optionPadding = getHorizontalPadding(this.selectedOption);
            const buttonBorder = this.button.offsetWidth - this.button.clientWidth;
            const optionWidth = Math.ceil(this.selectedOption.getBoundingClientRect().width);

            this.button.style.setProperty(
                "--custom-select-button-width",
                `${optionWidth - optionPadding + buttonPadding + buttonBorder}px`
            );
        }
    }

    customElements.define("custom-select", CustomSelect);
}